import { Route } from 'react-router-dom';

import { QRCODE_STATIC_STEP, QRCODE_STATIC_TYPE } from '~/constants/qr-code';
import { PATH } from '~/constants/route-path';
import { EditStaticType } from '~/pages/qrBuilder/p-static/p-common/EditStaticType';
import { CreateStaticEmailContent } from '~/pages/qrBuilder/p-static/p-static-email/p-static-email-content/CreateStaticEmailContent';
import { EditStaticEmailContent } from '~/pages/qrBuilder/p-static/p-static-email/p-static-email-content/EditStaticEmailContent';
import { StaticEmailStyles } from '~/pages/qrBuilder/p-static/p-static-email/StaticEmailStyles';
import { CreateStaticSmsContent } from '~/pages/qrBuilder/p-static/p-static-sms/p-static-sms-content/CreateStaticSmsContent';
import { EditStaticSmsContent } from '~/pages/qrBuilder/p-static/p-static-sms/p-static-sms-content/EditStaticSmsContent';
import { StaticSmsStyles } from '~/pages/qrBuilder/p-static/p-static-sms/p-static-sms-styles/StaticSmsStyles';
import { CreateStaticTextContent } from '~/pages/qrBuilder/p-static/p-static-text/p-static-text-content/CreateStaticTextContent';
import { EditStaticTextContent } from '~/pages/qrBuilder/p-static/p-static-text/p-static-text-content/EditStaticTextContent';
import { StaticTextStyles } from '~/pages/qrBuilder/p-static/p-static-text/StaticTextStyles';
import { CreateStaticURLContent } from '~/pages/qrBuilder/p-static/p-static-url/p-static-url-content/CreateStaticURLContent';
import { EditStaticURLContent } from '~/pages/qrBuilder/p-static/p-static-url/p-static-url-content/EditStaticURLContent';
import { StaticURLStyles } from '~/pages/qrBuilder/p-static/p-static-url/StaticURLStyles';
import { CreateStaticVCardContent } from '~/pages/qrBuilder/p-static/p-static-v-card/p-static-v-card-content/CreateStaticVCardContent';
import { EditStaticVCardContent } from '~/pages/qrBuilder/p-static/p-static-v-card/p-static-v-card-content/EditStaticVCardContent';
import { StaticVCardStyles } from '~/pages/qrBuilder/p-static/p-static-v-card/p-static-v-card-styles/StaticVCardStyles';
import { CreateStaticWhatsappContent } from '~/pages/qrBuilder/p-static/p-static-whatsapp/p-static-whatsapp-content/CreateStaticWhatsappContent';
import { EditStaticWhatsappContent } from '~/pages/qrBuilder/p-static/p-static-whatsapp/p-static-whatsapp-content/EditStaticWhatsappContent';
import { StaticWhatsappStyles } from '~/pages/qrBuilder/p-static/p-static-whatsapp/p-static-whatsapp-styles/StaticWhatsappStyles';
import { CreateStaticWifiContent } from '~/pages/qrBuilder/p-static/p-static-wifi/p-static-wifi-content/CreateStaticWifiContent';
import { EditStaticWifiContent } from '~/pages/qrBuilder/p-static/p-static-wifi/p-static-wifi-content/EditStaticWifiContent';
import { StaticWifiStyles } from '~/pages/qrBuilder/p-static/p-static-wifi/StaticWifiStyles';

import ProtectedRoute from './ProtectedRoute';

const CREATE_STATIC_CONTENT_PAGES = {
  [QRCODE_STATIC_TYPE.URL]: <CreateStaticURLContent />,
  [QRCODE_STATIC_TYPE.WIFI]: <CreateStaticWifiContent />,
  [QRCODE_STATIC_TYPE.TEXT]: <CreateStaticTextContent />,
  [QRCODE_STATIC_TYPE.EMAIL]: <CreateStaticEmailContent />,
  [QRCODE_STATIC_TYPE.SMS]: <CreateStaticSmsContent />,
  [QRCODE_STATIC_TYPE.WHATS_APP]: <CreateStaticWhatsappContent />,
  [QRCODE_STATIC_TYPE.VCARD]: <CreateStaticVCardContent />,
};

const EDIT_STATIC_CONTENT_PAGES = {
  [QRCODE_STATIC_TYPE.URL]: <EditStaticURLContent />,
  [QRCODE_STATIC_TYPE.WIFI]: <EditStaticWifiContent />,
  [QRCODE_STATIC_TYPE.TEXT]: <EditStaticTextContent />,
  [QRCODE_STATIC_TYPE.EMAIL]: <EditStaticEmailContent />,
  [QRCODE_STATIC_TYPE.SMS]: <EditStaticSmsContent />,
  [QRCODE_STATIC_TYPE.WHATS_APP]: <EditStaticWhatsappContent />,
  [QRCODE_STATIC_TYPE.VCARD]: <EditStaticVCardContent />,
};

const STATIC_STYLES_PAGES = {
  [QRCODE_STATIC_TYPE.URL]: <StaticURLStyles />,
  [QRCODE_STATIC_TYPE.WIFI]: <StaticWifiStyles />,
  [QRCODE_STATIC_TYPE.TEXT]: <StaticTextStyles />,
  [QRCODE_STATIC_TYPE.EMAIL]: <StaticEmailStyles />,
  [QRCODE_STATIC_TYPE.SMS]: <StaticSmsStyles />,
  [QRCODE_STATIC_TYPE.WHATS_APP]: <StaticWhatsappStyles />,
  [QRCODE_STATIC_TYPE.VCARD]: <StaticVCardStyles />,
};

export const QR_BUILDER_ROUTES = [
  // create static content routes
  ...Object.entries(CREATE_STATIC_CONTENT_PAGES).map(([type, element]) => (
    <Route
      key={`create-static-${type}`}
      path={PATH.QR.CREATE_QR_STATIC_CONTENT(type)}
      element={<ProtectedRoute>{element}</ProtectedRoute>}
    />
  )),

  // edit static type route
  <Route
    key="edit-static-type"
    path={PATH.QR.EDIT_QR_STATIC(QRCODE_STATIC_STEP.TYPE)}
    element={
      <ProtectedRoute>
        <EditStaticType />
      </ProtectedRoute>
    }
  />,

  // edit static content routes
  ...Object.entries(EDIT_STATIC_CONTENT_PAGES).map(([type, element]) => (
    <Route
      key={`edit-static-content-${type}`}
      path={PATH.QR.EDIT_QR_STATIC(QRCODE_STATIC_STEP.CONTENT, type)}
      element={<ProtectedRoute>{element}</ProtectedRoute>}
    />
  )),

  // edit static styles routes
  ...Object.entries(STATIC_STYLES_PAGES).map(([type, element]) => (
    <Route
      key={`edit-static-styles-${type}`}
      path={PATH.QR.EDIT_QR_STATIC(QRCODE_STATIC_STEP.STYLES, type)}
      element={<ProtectedRoute>{element}</ProtectedRoute>}
    />
  )),
];
